import { Expose } from 'class-transformer'

export class TopWriterBySaleType {
  @Expose() userId: number

  @Expose() username: string

  @Expose() userMoneyReceived: number

  @Expose() writerId: number
}
